import { LockOutlined } from '@ant-design/icons';
import { ScopeButton } from '@monorepo/shared-lib';
import { Space } from 'antd';
import GenTaxImage from 'assets/images/gen-tax-img-cropped.svg';
import { StyledCard } from 'components/Custom/card';
import { CardDescSpan, CardTitleLargeSpan } from 'components/Custom/spans';
import { StyledTooltip } from 'components/Custom/Tooltip';
import { UpgradeMessage } from 'containers/UpgradeMessage';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { turnModalOff, turnModalOn } from 'store/app/actions';
import { UpgradeMessageSource, WindowType } from 'store/app/enums';
import { reactivateOrganisationRequest } from 'store/organisation/actions';
import { Organisation } from 'store/organisation/models';

interface ReactivationPanelProps {
  organisation?: Organisation;
}

export const ReactivationPanel: React.FC<ReactivationPanelProps> = ({
  organisation,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleReactivateEntity = () => {
    if (organisation?.uuid) {
      dispatch(reactivateOrganisationRequest(organisation.uuid));
    }
  };

  const showReactivateConfirmation = () => {
    dispatch(
      turnModalOn({
        title: '',
        type: WindowType.WARNING,
        component: (
          <UpgradeMessage
            source={UpgradeMessageSource.REACTIVATE_ENTITY}
            callback={handleReactivateEntity}
            onClose={() => dispatch(turnModalOff())}
          />
        ),
      })
    );
  };

  return (
    <StyledCard
      $nopadding
      fullsize
      style={{
        border: '1px solid var(--color-text-muted, #5a6a6a)',
        boxShadow: '0px 4px 10px 0px #0000000D',
        marginBottom: '20px',
        display: 'flex',
        fontSize: 14,
        fontWeight: 400,
        padding: 0,
      }}
      width="100%"
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexFlow: 'row',
          alignContent: 'end',
          padding: '24px 24px 0 0',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'space-between',
            padding: '0 24px 24px 24px',
          }}
        >
          <Space>
            <StyledTooltip title={t('organisation.view-only-state-tooltip')}>
              <CardTitleLargeSpan style={{ marginBottom: 10 }}>
                {t('organisation.view-only-entity-title')}
              </CardTitleLargeSpan>
            </StyledTooltip>
          </Space>
          <CardDescSpan style={{ marginBottom: 16 }}>
            {t('organisation.view-only-entity-description')}
          </CardDescSpan>

          <ScopeButton
            type="primary"
            width="132px"
            height="40px"
            style={{ fontSize: '13px', fontWeight: 700 }}
            onClick={showReactivateConfirmation}
          >
            {t('organisation.reactivate-entity')}
          </ScopeButton>
        </div>

        <div
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'end',
          }}
        >
          <img
            alt={t('organisation.view-only-entity-alt')}
            src={GenTaxImage}
            style={{ opacity: 0.5 }}
          />
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: 'rgba(135, 148, 148, 0.9)',
              borderRadius: '50%',
              padding: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <LockOutlined style={{ color: '#fff', fontSize: 32 }} />
          </div>
        </div>
      </div>
    </StyledCard>
  );
};
